import { ProgressStatus } from 'constants/progressStatus';

const verbsObject: Record<ProgressStatus, string> = {
  [ProgressStatus.PASSED]: '[passed]',
  [ProgressStatus.FAILED]: '[not passed]',
  [ProgressStatus.IN_PROGRESS]: '[not passed yet]'
};

export const getProgressStatusLocalizationKey = (status: number) => {
  return verbsObject[status as ProgressStatus];
};
